<template>
  <section
    class="py-[42px] lg:py-21"
    :class="{
      'background-pattern-navy-500--hero': backgroundColour === 'navy',
      'background-pattern-mono-light': backgroundColour === 'white',
    }"
  >
    <ContentContainer>
      <slot name="defaultHeader" />
    </ContentContainer>
  </section>
</template>

<script setup lang="ts">
const props = defineProps<{
  backgroundColour?: 'white' | 'navy';
}>();

defineSlots<{
  defaultHeader?(): any;
}>();
</script>
